// global window:true

const serverFetch = () => () => Promise.resolve();

const clientFetch = () => {
  // eslint-disable-next-line
  return window.fetch;
};

// eslint-disable-next-line
const fetch = window && window.document ? clientFetch() : serverFetch();

export { fetch };
